import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export  class RedirectService {
  constructor(private router: Router) { }

  redirectTo(location, openInNewTab = false): void {
    if (openInNewTab) {
      window.open(location, '_blank');
    } else {
      window.location.replace(location);
    }
  }

  // a url forwarded by a slash is considered to be an internal route,
  // while a url that doesn't start with a slash is considered to be an external url
  navigateOrRedirectTo(path): void {
    if (path) {
      if (this.isLocalPath(path)) {
        this.router.navigateByUrl(path);
        return;
      } else {
        this.redirectTo(path);
        return;
      }
    }
  }

  isLocalPath(path: string): boolean {
    return path[0] === '/';
  }
}
